import React from 'react';

export const TitleBar = React.memo(({ pageContent, affiliationData }) => {
	const titleTemplateClassname = window?.template === "YB-1" ? "mb-0" : ""
	const titleClassName = `titleBarHeading ${titleTemplateClassname}`

	return (
		<div className='row mx-0 mt-3 container-fluid'>
			<h1 className={titleClassName}>
				{
					pageContent.headingPreText 
						? <span className={'mr-2'} dangerouslySetInnerHTML={{ __html: pageContent.headingPreText }} />
						: ""
				} 
				<span dangerouslySetInnerHTML={{ __html: affiliationData.name }} /> 
				{
					pageContent.headingPostText 
						? <span className={'ml-2'} dangerouslySetInnerHTML={{ __html: pageContent.headingPostText }} />
						: ""
				}
			</h1>
		</div>
	);
});
